<div class="wrapper">
	<div class="value">
		{{ goal.value }}
	</div>
</div>
